import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { GroupBaseModel } from '@smarttask-common/src/lib/models/Group/Core/GroupBaseModel';

export enum GroupActionTypes {
    ADD_GROUP = '[Group] Create Group',
    ADD_GROUPS = '[Group] Add Groups',
    UPSERT_GROUP = '[Group] Upsert Group',
    UPSERT_GROUPS = '[Group] Upsert Groups',
    UPDATE_GROUP = '[Group] Update Group',
    UPDATE_GROUPS = '[Group] Update Groups',
    DELETE_GROUP = '[Group] Delete Group',
    DELETE_GROUPS = '[Group] Delete Groups',
    DELETE_ALL_GROUPS = '[Group] Delete All Groups',
    DELETE_ALL = '[Group] Delete All',

    UPDATE_SELECTED_ID = '[group] Update SelectedId',
}

export class UpdateSelectedGroupId implements Action {
    readonly type = GroupActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_group_id: number) {}
}

export class AddOne implements Action {
    readonly type = GroupActionTypes.ADD_GROUP;
    constructor(public group: GroupBaseModel) {}
}

export class AddMany implements Action {
    readonly type = GroupActionTypes.ADD_GROUPS;
    constructor(public groups: Array<GroupBaseModel>) {}
}

export class UpsertOne implements Action {
    readonly type = GroupActionTypes.UPSERT_GROUP;

    constructor(public group: GroupBaseModel) {}
}

export class UpsertMany implements Action {
    readonly type = GroupActionTypes.UPSERT_GROUPS;
    constructor(public groups: Array<GroupBaseModel>) {}
}

export class UpdateOne implements Action {
    readonly type = GroupActionTypes.UPDATE_GROUP;
    constructor(public group: Update<GroupBaseModel>) {}
}

export class UpdateMany implements Action {
    readonly type = GroupActionTypes.UPDATE_GROUPS;
    constructor(public groups: Array<Update<GroupBaseModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = GroupActionTypes.DELETE_GROUP;
    constructor(public id: number) {}
}

export class DeleteMany implements Action {
    readonly type = GroupActionTypes.DELETE_GROUPS;
    constructor(public ids: Array<number>) {}
}

export class DeleteAll implements Action {
    readonly type = GroupActionTypes.DELETE_ALL_GROUPS;
    constructor(public ids: Array<number>) {}
}

export class DeleteState implements Action {
    readonly type = GroupActionTypes.DELETE_ALL;
    constructor() {}
}

export type GroupActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedGroupId;
